var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-center" }, [
    _c("div", { staticClass: "box" }, [
      _vm.invalid
        ? _c("div", [
            _c("img", {
              staticClass: "mb-30",
              attrs: {
                src: "/static/icon-error.svg",
                height: "80px",
                alt: "broom"
              }
            }),
            _vm._v(" "),
            _c("b", [_vm._v("Ocorreu um erro!")]),
            _vm._v("\n      O token informado não é valido.\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.valid
        ? _c("div", [
            _c("img", {
              staticClass: "mb-30",
              attrs: {
                src: "/static/icon-success.svg",
                height: "80px",
                alt: "broom"
              }
            }),
            _vm._v(" "),
            _c("b", [_vm._v("Seu e-mail foi verificado com sucesso!")]),
            _vm._v(
              "\n      Agora você já pode realizar compras na nossa plataforma.\n      "
            ),
            _c("br"),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        Você será redirecionado em\n        "),
              _c("b", [_vm._v(_vm._s(_vm.seconds) + " segundos")]),
              _vm._v(".\n      ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.preloader
        ? _c("div", { staticClass: "preloader" }, [
            _c("img", { attrs: { src: "/static/broom.gif", alt: "broom" } }),
            _vm._v(" "),
            _c("b", [_vm._v("Aguarde,")]),
            _vm._v("\n      Estamos verificando a sua conta de e-mail.\n    ")
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d07929ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d07929ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VerifyEmail.vue
// module id = null
// module chunks = 